import {AppInsightsAdapter} from '@hconnect/common/logging'
import {CircularProgress} from '@mui/material'
import React, {Suspense} from 'react'
import ReactDOM from 'react-dom'

import {App} from './App'
import {initLocalization} from './localization'

void initLocalization()
AppInsightsAdapter.init()
// Tracking information and logs will be sent to azure
AppInsightsAdapter.allowTracking()

ReactDOM.render(
  <Suspense fallback={<CircularProgress />}>
    <App />
  </Suspense>,
  document.getElementById('root')
)
